module.exports = __webpack_public_path__ + "fonts/CosmopolitanScript-Regular.fbadd435.eot";